import {gettext} from 'topmeteo/utils/i18n';

import Dialog from './Dialog';

const ResetFavouritesLabel = gettext('Reset Favorites');

const Button = ({show, onClick, ...props}) => (
    <a id="reset-favorites" className="link reset" onClick={onClick}>
        <span>{ResetFavouritesLabel}</span>
        {show && <Dialog {...props} headline={ResetFavouritesLabel} />}
    </a>
);

export default Button;
